import Plyr from "plyr";

class AudioPlayer {

    protected playerContainer = '.podcasts__player-container';
    protected audioContainer = $(this.playerContainer + ' audio');
    protected playlist = [];
    protected currentTrack = 0;
    protected audioPlayer;
    protected currentInterval;
    protected isPlayed = false;

    constructor() {
        /*$('.js-slider-item').each((i, e) => {
            this.playlist.push({
                src: $(e).find('input').val(),
                img: $(e).find('input').data('img'),
                name: $(e).find('.podcast-release-item-title').text(),
                desc: $(e).find('.podcast-release-item-description').text().trim()
            });
        });*/
        let inputAudioInfo = $('.js-audio-first-element');
        this.playlist.push({
            src: inputAudioInfo.val(),
            img: inputAudioInfo.data('img'),
            //name: $(e).find('.podcast-release-item-title').text(),
            //desc: $(e).find('.podcast-release-item-description').text().trim()
        });

        this.loadFile(this.currentTrack);

        this.customRange(this.playerContainer + ' .custom-range');
        $(document)
            .on('input', this.playerContainer + ' .custom-range', (e) => {this.customRange(e.currentTarget)})
            .on('click', this.playerContainer + ' .js-podcasts-play-btn', this.play.bind(this))
            .on('click', this.playerContainer + ' .audio-sound-range', this.soundRange.bind(this))
            .on('click', this.playerContainer + ' .btn-prev', this.prevTrack.bind(this))
            .on('click', this.playerContainer + ' .btn-next', this.nextTrack.bind(this));
    }

    play() {
        if (this.audioPlayer.paused) {
            this.audioPlayer.play();
            $('.js-podcasts-play-btn').addClass('audio-played');
        } else {
            this.audioPlayer.pause();
            $('.js-podcasts-play-btn').removeClass('audio-played');
        }

        this.isPlayed = !this.audioPlayer.paused;
    }

    timeFormat(duration) {
        var hrs = ~~(duration / 3600);
        var mins = ~~((duration % 3600) / 60);
        var secs = ~~duration % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    loadFile(trackId) {

        this.audioContainer.remove();
        $('.podcasts__player-progress-bar').prepend(
            new Audio(this.playlist[trackId].src)
        );

        if (this.audioPlayer) {
            this.audioPlayer.destroy();
        }

        this.audioPlayer = new Plyr(this.playerContainer + ' audio', {
            debug: false,
            controls: ['progress']
        });

        this.audioPlayer.on('timeupdate', (event) => {
            const instance = event.detail.plyr;
            let time = this.timeFormat(Math.round(instance.currentTime));
            $('.podcasts__player-props-time').html(time)
        });

        this.setAttr(trackId);

        this.audioPlayer.on('ended', () => {this.nextTrack()});

        if (this.isPlayed) {
            this.play();
        }

        this.currentTrack = trackId;
    }

    setAttr(trackId) {
        let track = this.playlist[trackId];

        //$('.podcasts-preview-desktop-img img').attr('src', track.img);
        //$('.podcasts-preview-desktop-item-title').html(track.name).attr('title', track.name);
        //$('.podcasts-preview-desktop-item-subtitle').html(track.desc);
    }


    nextTrack() {
        /*let next = this.currentTrack + 1;

        if (next > this.playlist.length - 1)
            next = 0;

        this.loadFile(next);*/
        this.audioPlayer.forward(15);
    }

    prevTrack() {
        /*let next = this.currentTrack - 1;

        if (next < 0)
            next = this.playlist.length - 1;

        this.loadFile(next);*/

        this.audioPlayer.forward(-15);
    }

    soundRange(e) {
        this.audioPlayer.volume = parseFloat($(e.currentTarget).val().toString()) / 100;
    }

    customRange(e) {
        $(e).css('--value', $(e).val().toString() + '%');
    }

}

export default AudioPlayer;
